import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output } from '@angular/core';

class LabelColumnComponent {
    constructor() {
        this.hintPosition = 'left';
        this.hintIconLeftAlign = false;
        this.linkTitle = '';
        this.showLink = false;
        this.icon = 'fa-question-circle';
        this.onClickLink = new EventEmitter();
        this.offsetClass = '';
    }
    ngOnInit() {
        if (this.offset && this.offset.length > 0) {
            this.offsetClass = `col-md-offset-${this.offset}`;
        }
    }
    clickLink() {
        this.onClickLink.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LabelColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: LabelColumnComponent, isStandalone: true, selector: "elo-label-column", inputs: { label: "label", color: "color", column: "column", offset: "offset", hintMessage: "hintMessage", hintPosition: "hintPosition", hintIconLeftAlign: "hintIconLeftAlign", linkTitle: "linkTitle", showLink: "showLink", icon: "icon" }, outputs: { onClickLink: "onClickLink" }, ngImport: i0, template: "<div class=\"col-md-{{column}} {{offsetClass}}\">\n  <div class=\"form-group\">\n    <label class=\"label\" [style.color]=\"color\">\n      {{ !hintIconLeftAlign ? label : '' }}\n      <i *ngIf=\"hintMessage\" class=\"hint fa {{icon}} clean module-color sm inline {{hintPosition}}\">\n        <div class=\"hint-content\" [innerHTML]=\"hintMessage\"></div>\n      </i>\n      {{ hintIconLeftAlign ? label : ''}}\n\n      <a (click)=\"clickLink()\" class=\"pull-right\" *ngIf=\"showLink\">\n        <u id=\"linkTitle\">{{linkTitle}}</u>\n      </a>\n    </label>\n    <ng-content></ng-content>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LabelColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'elo-label-column', standalone: true, imports: [
                        CommonModule
                    ], template: "<div class=\"col-md-{{column}} {{offsetClass}}\">\n  <div class=\"form-group\">\n    <label class=\"label\" [style.color]=\"color\">\n      {{ !hintIconLeftAlign ? label : '' }}\n      <i *ngIf=\"hintMessage\" class=\"hint fa {{icon}} clean module-color sm inline {{hintPosition}}\">\n        <div class=\"hint-content\" [innerHTML]=\"hintMessage\"></div>\n      </i>\n      {{ hintIconLeftAlign ? label : ''}}\n\n      <a (click)=\"clickLink()\" class=\"pull-right\" *ngIf=\"showLink\">\n        <u id=\"linkTitle\">{{linkTitle}}</u>\n      </a>\n    </label>\n    <ng-content></ng-content>\n  </div>\n</div>\n" }]
        }], propDecorators: { label: [{
                type: Input
            }], color: [{
                type: Input
            }], column: [{
                type: Input
            }], offset: [{
                type: Input
            }], hintMessage: [{
                type: Input
            }], hintPosition: [{
                type: Input
            }], hintIconLeftAlign: [{
                type: Input
            }], linkTitle: [{
                type: Input
            }], showLink: [{
                type: Input
            }], icon: [{
                type: Input
            }], onClickLink: [{
                type: Output
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { LabelColumnComponent };
